export default __webpack_public_path__ + "static/media/AES_Emblem_v.1.3_Global.2cd87853.png";